/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlogCards, FeaturePanel } from "@components/elements";
import { BlogCardFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";

export type TabbedBlogCardsMoleculeProps = {
	cards: BlogCardFragment[];
	isFirstCardRow: boolean;
	cardGridFitToWidth?: boolean;
};

const fullWidthStyle = css({ w: "full" });

export const TabbedBlogCardsMolecule = ({
	cards,
	isFirstCardRow,
	cardGridFitToWidth,
}: TabbedBlogCardsMoleculeProps): React.JSX.Element | null => {
	return (
		<>
			{isFirstCardRow && cards[0] ? (
				<div className={cx("featured-card-row", fullWidthStyle)}>
					<FeaturePanel
						verticallyCenter
						title={cards[0].title}
						desc={cards[0].desc}
						modButtons={cards[0].buttons}
						asset={{ ...cards[0].asset, optUrl: "" } as BlogCardFragment["asset"]}
						eyebrow={cards[0].eyebrow}
						eyebrowBadges={[]}
						buttonSize="md"
						links={[]}
					/>
				</div>
			) : null}
			{cards?.length ? (
				<BlogCards
					cards={(isFirstCardRow ? cards.slice(1) : cards) || []}
					maxRowSize={4}
					direction="column"
					className={fullWidthStyle}
					rowSizeOverride={!cardGridFitToWidth ? 4 : undefined}
				/>
			) : null}
		</>
	);
};
